import { render, staticRenderFns } from "./myinfo-tab-verify.vue?vue&type=template&id=1afaa017&"
import script from "./myinfo-tab-verify.vue?vue&type=script&lang=js&"
export * from "./myinfo-tab-verify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports